import React, { useEffect, useState, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link, useNavigate, useParams } from 'react-router-dom'
import ForgotPassword from './ForgotPassword'
import Login from './Login'
import Spinner from '../ui-elements/Spinner'
import RedAlert from '../ui-elements/RedAlert'
import GuestUserLoginForm from './GuestUserLoginForm'
import ChooseLoginType from './ChooseLoginType'
import SwitchLanguage from '../ui-elements/SwitchLanguage'

type Props = {
    showForm: string
    loginOptions: null | ObjectStringKeyAnyValue

}


function NotLoggedIn({
    showForm = 'login',
    loginOptions
}: Props) {

    const {
        idToken,
        accessToken
    } = useContext(GlobalContext)
    const navigate = useNavigate()
    const { checklistId } = useParams()
    const [deleteLocalStorage, setDeleteLocalStorage] = useState(false)


    useEffect(() => {
        const mismatchedChecklistId = localStorage.getItem('mismatchedChecklistId')
        mismatchedChecklistId && checkForChecklistIdInLocalStorage(mismatchedChecklistId)
    }, [])


    useEffect(() => {
        if (deleteLocalStorage) {
            localStorage.removeItem('mismatchedChecklistId')
        }
    }, [deleteLocalStorage])


    const checkForChecklistIdInLocalStorage = (mismatchedChecklistId: string) => {
        //console.log('💟')
        const windowpath = window.location.pathname
        if (windowpath === "/" && mismatchedChecklistId) {
            //console.log('🚨 Found mismatched checklist id in local storage')
            navigate(`/start-checklist/${mismatchedChecklistId}`)
            setDeleteLocalStorage(true)
        } else {
            //console.log('🪼')
        }
    }


    const haveGotTokens = idToken && accessToken

    return <div className={`bg-brandblue flex flex-col min-h-screen items-center justify-between text-center gap-4 p-4 text-white`}>

        <div className={`w-full flex-1 flex flex-col justify-center items-center`}>

            <div className={`w-full max-w-sm flex flex-col gap-6 items-center justify-center`}>

                <img
                    src={`/logos/logo-white-no-strapline.svg`}
                    alt={'ChecQR logo'}
                    className={`w-72`}
                />


                {haveGotTokens && <Spinner size='large'>Logging in...</Spinner>}
                {!haveGotTokens && showForm === 'forgotPassword' && <ForgotPassword />}
                {!haveGotTokens && showForm === 'login' && <Login loginOptions={loginOptions} />}

                {!haveGotTokens && checklistId && !loginOptions && <Spinner>Checking login options...</Spinner>}
                {!haveGotTokens && loginOptions && Object.keys(loginOptions).length === 0 && <RedAlert>No login options set up for this organisation</RedAlert>}

            </div>

        </div >

        <SwitchLanguage
            selectedButtonClass='white'
            unSelectedButtonClass='secondary'
        />
        <a href='https://checqr.net/what-is-checqr-about' className={`mb-4 text-sm text-white underline hover:opacity-80`}>What is ChecQR all about?</a>

    </div >
}
export default NotLoggedIn